import { Pipe, PipeTransform } from '@angular/core';
import { translateInvitationStatus } from '../mappers/enum-translation-mapper';
import { InvitationStatus } from '../enums/invitation-status.enum';

@Pipe({
  name: 'translateInvitationStatusEnum',
})
export class TranslateInvitationStatusEnum implements PipeTransform {
  transform(value: any): any {
    if (Array.isArray(value)) {
      value.forEach(element => {
        const problemTypeEnum = element as { name: any; index: any };
        problemTypeEnum.name = translateInvitationStatus(problemTypeEnum.index);
      });
      return value;
    }
    const enumValue: InvitationStatus = InvitationStatus[value as keyof typeof InvitationStatus];
    return translateInvitationStatus(enumValue);
  }
}
